import React, { Component } from 'react';
import './styles.scss';

type Props = {
  text: string;
  onClick: Function;
  disabled?: boolean;
  theme:
    | 'light'
    | 'dark'
    | 'secondary-blue'
    | 'take-over-chat'
    | 'secondary-blue-without-border'
    | 'dark-blue'
    | 'red';
  custId?: any;
  collectStatus?: string;
  endStatus?: string;
};
type State = {};

export default class Button extends Component<Props, State> {
  render() {
    return (
      <div
        className={`sf-button ${this.props.theme} ${
          this.props.disabled ? 'disabled' : 'clickable'
        } ${this.props.text === 'Transfer Chat' ? 'transfer-chat' : ''} ${
          this.props.text === 'End Chat' ? 'end-chat' : ''
        } ${
          this.props.text === 'Take Over'
            ? `take-over-chat custId_${this.props.custId}`
            : ''
        } ${this.props.collectStatus ? 'collect-status' : ''}`}
        onClick={() => {
          this.props.onClick();
        }}
        style={
          this.props.endStatus === 'true'
            ? { border: '1px solid #6c7ef2', backgroundColor: '#6c7ef2' }
            : this.props.endStatus === 'cancel'
            ? { border: '1px solid #6c7ef2', color: '#6c7ef2' }
            : {}
        }>
        {this.props.text}
      </div>
    );
  }
}
